export default __webpack_public_path__ + "static/media/falcon.c1d0a8d1.jpg";